/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 * @param {string} partNumber - SKU to be fetched
 */

const findClubData = (brand, partNumber) => (
    gql`{ findProductByPartNumber(brand: "${brand}", environment: "${GRAPHQL_ENV}", partNumber: "${partNumber}") {
            id
                name
                legacyId
                image {
                    name
                    path
                }
                availability {
                    earliestShipDate
                    deliveryMessage
                }
                prices {
                    type
                    value
                    __typename
                }
                club {
                    defaultSku {
                        partNumber
                        availableDate
                        month
                        partNumber
                        startDate
                        endDate
                        image{
                            name
                            path
                        }
                        components{
                            partNumber
                            name
                            month
                            longDescription
                            shortDescription
                            productContents
                            startDate
                            endDate
                            availableDate
                            frequency
                            image{
                                name
                                path
                            }
                        }
                        frequency
                        upsells{
                            partNumber
                            month
                            name
                            startDate
                            longDescription
                            shortDescription
                            productContents
                            endDate
                            frequency
                            upSellDisplayPrice
                            image{
                                name
                                path
                            }
                        }
                    }
                    allItemsList {
                        month
                        frequency
                        availableDate
                        partNumber
                        id
                        startDate
                        endDate
                        availableDate
                        image{
                            name
                            path
                            altText
                        }
                    }
                }
        }
    }
`
);

const findSkuById = (brand, productId) => (
    gql(`
    {
        findSkuById(brand:"${brand}", environment: "${GRAPHQL_ENV}", id: "${productId}")
        {
            id
            partNumber
            name
            legacyId
            image {
                name
                path
            }
            availability {
                earliestShipDate
                deliveryMessage
            }
            prices {
                type
                value
                __typename
            }
            clubItem {
                partNumber
                month
                name
                startDate
                availableDate
                frequency
                image{
                    name
                    path
                }
                endDate
                components {
                    partNumber
                    name
                    month
                    startDate
                    endDate
                    availableDate
                    longDescription
                    shortDescription
                    productContents
                    frequency
                    image {
                        name
                        path
                    }
                }
                upsells {
                    partNumber
                    month
                    name
                    startDate
                    endDate
                    longDescription
                    shortDescription
                    productContents
                    frequency
                    upSellDisplayPrice
                    image{
                        name
                        path
                    }
                }
            }
        }
    }
    `)
);

export default { findClubData, findSkuById };
